import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from "firebase/storage";
import { getDatabase } from 'firebase/database';
import { getFunctions, httpsCallable } from 'firebase/functions';

// Firebase configuration object (replace with your own values)
const firebaseConfig = {
    apiKey: "AIzaSyDRZX9LBd9qhrOTq9M5Dtim1lzV5_Pl-g4",
    projectId: "independentloyalist",
    databaseURL: "https://independentloyalist-default-rtdb.europe-west1.firebasedatabase.app/",
    storageBucket: "gs://independentloyalist.appspot.com",
    messagingSenderId: "929450309163"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const storage = getStorage(app);
const database = getDatabase(app);
const functions = getFunctions(app);

// Export initialized services
export { auth, storage, database, functions, httpsCallable };